import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import './DepartmentHero.css';

const DepartmentHero = ({ 
  title, 
  breadcrumb, 
  background, 
  subtitle, 
  height = 'large',
  gradient = 'linear-gradient(135deg, #0a0a1a 0%, #1a2a4a 100%)',
  badge
}) => {
  const { t } = useTranslation();

  const heroStyle = {
    background: background ? `url(${background}) center center / cover no-repeat` : gradient,
  };

  return (
    <section 
      className={`department-hero ${height === 'small' ? 'hero-small' : 'hero-large'}`}
      style={heroStyle}
    >
      <div className="department-hero-overlay"></div>
      
      {/* Effet de particules en arrière-plan */}
      <div className="hero-particles">
        <span></span><span></span><span></span><span></span>
        <span></span><span></span><span></span><span></span>
      </div>

      <div className="container">
        <motion.div
          className="department-hero-content"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.25, 0.1, 0.25, 1] }}
        >
          <motion.div
            className="hero-badge"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <span className="badge-dot"></span>
            {badge || `${t('Services')} / ${t('Sous_Services_BTP')}`}
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7, delay: 0.1 }}
          >
            {title}
          </motion.h1>

          {subtitle && (
            <motion.p
              className="hero-subtitle"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              {subtitle}
            </motion.p>
          )}

          <motion.div
            className="department-breadcrumb"
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            <span>
              <a href="/">{t('menu_Accueil')}</a>
            </span>
            <span className="separator">›</span>
            {breadcrumb.map((item, index) => (
              <span key={index}>
                {index === breadcrumb.length - 1 ? (
                  <span className="breadcrumb-current">{item.label}</span>
                ) : (
                  <a href={item.link}>{item.label}</a>
                )}
                {index < breadcrumb.length - 1 && (
                  <span className="separator">›</span>
                )}
              </span>
            ))}
          </motion.div>

          {/* Ligne décorative animée en étoile filante */}
          <div className="hero-line-wrapper">
            <div className="hero-line"></div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default DepartmentHero;